import {
  brand,
  BRAND_ID,
  type BrandConfig,
  type BrandId,
  isHappa,
  isSais,
  paymentsEnabled
} from '@/config/brand'

export { brand, BRAND_ID, isHappa, isSais, paymentsEnabled }
export type { BrandConfig, BrandId }

/**
 * Hook that returns brand configuration.
 * Use this in components to conditionally render brand-specific UI.
 */
export function useBrand(): BrandConfig {
  return brand
}
